module.exports = __webpack_public_path__ + "img/title5.4f539e5f.png";